import React, { useState, useEffect, useRef, useMemo } from 'react';
import { customDateFormatShort } from '../../config/utils';
import { FaFileExcel } from 'react-icons/fa';
import { toast } from 'react-toastify';
import vendorService from '../../services/vendorService';


const ApprovalsVendor = () => {
    const [Squads, setSquads] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedSquad, setSelectedSquad] = useState(null);
    const [selectedApproval, setSelectedApproval] = useState(null);
    const [actionType, setActionType] = useState(null); // 'approve' | 'reject'
    const [showVendorApprovalModal, setVendorApprovalModal] = useState(false);
    const [showVendorRejectedModal, setVendorRejectedModal] = useState(false);
    const [approvals, setApprovals] = useState([]);
    const [formData, setFormData] = useState({
        status: "",
        approval_notes: "",
        rejection_reason: ""
    });

    const [filters, setFilters] = useState({
        status: [],
        project_id: '',
        name: '',
        code: '',
    });

    console.log('approvals222===:', approvals);
    console.log('selectedApproval333===:', selectedApproval);
    console.log('actionType444===:', actionType);

    useEffect(() => {
        getVendorApprovals();
    }, []);

    const getVendorApprovals = async () => {
        try {
            const data = await vendorService.getVendorApprovals();
            setApprovals(data.approvals);

            console.log(' approvals11===:', approvals);
        } catch (err) {
            console.error('Failed to fetch approvals:', err);
        }
    };

    const updateApprovalReason = async () => {
        const payload =
            actionType === "approve"
                ? {
                    status: "Approved",
                    approved_amount: selectedApproval.approved_amount,
                    approval_notes: formData.approval_notes,
                }
                : {
                    status: "Rejected",
                    approved_amount: selectedApproval.approved_amount,
                    rejection_reason: formData.rejection_reason,
                };

        try {
            const res = await vendorService.updateVendorApprovals(selectedApproval.id, payload);
            toast.success(`Approval ${actionType === "approve" ? "approved" : "rejected"} successfully`);
            setVendorApprovalModal(false);
            setVendorRejectedModal(false);
            setFormData({ status: "", approval_notes: "", rejection_reason: "" });
            getVendorApprovals(); // refresh the list
        } catch (error) {
            console.error("Error:", error);
            toast.error("Failed to update approval");
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const vendorApprovalModal = (e, status) => {
        setSelectedApproval(e);
        setActionType(status);
        if (status === "approve") {
            setVendorApprovalModal(true);
        } else {
            setVendorRejectedModal(true);
        }
    };


    const filteredSquads = useMemo(() => {
        return Squads.filter((squad) => {
            const statusMatch =
                !filters.status.length || filters.status.includes(squad.status);

            const projectMatch =
                !filters.project_id ||
                String(squad.project?.id) === String(filters.project_id);

            const nameMatch =
                !filters.name ||
                squad.name?.toLowerCase().includes(filters.name.toLowerCase());

            const codeMatch =
                !filters.code ||
                squad.squad_code?.toLowerCase().includes(filters.code.toLowerCase());

            return statusMatch && projectMatch && nameMatch && codeMatch;
        });
    }, [Squads, filters]);

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        return customDateFormatShort(dateString);
    };
    
    const handleDownloadSquadList = () => {
        if (!filteredSquads || filteredSquads.length === 0) {
            toast.error('No squads to download');
            return;
        }

        const headers = [
            'Squad Code', 'Squad Name', 'Project', 'Status',
            'Created At', 'Updated At'
        ];

        const escapeCsv = (value) => {
            if (value === null || value === undefined) return '';
            const str = String(value);
            if (str.includes(',') || str.includes('"') || str.includes('\n')) {
                return `"${str.replace(/"/g, '""')}"`;
            }
            return str;
        };

        const rows = filteredSquads.map((squad) => [
            squad.squad_code,
            squad.name,
            squad.project ? `${squad.project.name} (${squad.project.code})` : 'N/A',
            squad.status,
            formatDate(squad.createdAt),
            formatDate(squad.updatedAt)
        ]);

        const csvContent = [headers, ...rows]
            .map((row) => row.map(escapeCsv).join(','))
            .join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.download = `squad-list-${new Date().toISOString().slice(0, 10)}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        toast.success('Squad list downloaded');
    };

    return (
        <div className="squad-list-container">
            <div className="squad-list-header">
                <h2 style={{ fontSize: 'xx-large', fontWeight: 'bold' }}>Approvals</h2>
                {/* <Link to="/app/squads/new" className="btn btn-primary">
             <i className="fas fa-plus"></i> New Approval
           </Link> */}
                <div className='ms-4'>
                    <button
                        onClick={handleDownloadSquadList}
                        className="px-4 py-3 bg-white border border-green-600 text-green-600 rounded-lg flex items-center gap-2"
                        title="Download squad list"
                    >
                        <FaFileExcel />
                    </button>
                </div>
            </div>


            {loading ? (
                <div className="loading">Loading Approval...</div>
            ) : (
                <div className="table-responsive overflow-x-auto bg-white rounded-lg shadow border border-gray-200 mt-5">
                    <table className="table squad-table">
                        <thead>
                            <tr>
                                <th>Title</th>
                                <th>Approval type</th>
                                <th>Priority</th>
                                <th>Status</th>
                                <th>Requested by</th>
                                <th>Approver</th>
                                <th>Description</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {approvals?.map((app) => (
                                <tr key={app.id}>
                                    <td>{app.title}</td>
                                    <td>{app.approval_type}</td>
                                    <td>{app.priority}</td>
                                    <td>{app.status}</td>
                                    <td>{app.requester.first_name} {app.requester.last_name}</td>
                                    <td> {app.approval_category} </td>
                                    <td>{customDateFormatShort(app.due_date)}</td>
                                    <td>
                                        <div class="action-buttons">
                                            <button class="btn btn-sm btn-info" title="View"><i class="fas fa-eye"></i></button>
                                            <button onClick={() => { vendorApprovalModal(app, 'approve') }} class="btn btn-sm btn-success" title="Approve"><i class="fas fa-check"></i></button>
                                            <button
                                                onClick={() => vendorApprovalModal(app, 'reject')}
                                                className="btn btn-sm btn-danger"
                                                title="Reject"
                                            >
                                                <i className="fas fa-times"></i>
                                            </button>
                                            <button class="btn btn-sm btn-danger" title="Delete"><i class="fas fa-trash"></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {showVendorApprovalModal && selectedApproval && (
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
                    onClick={() => setVendorApprovalModal(false)}
                >
                    <div
                        className="w-[50%] overflow-hidden rounded-xl bg-white shadow-2xl"
                        onClick={(e) => e.stopPropagation()}
                    >

                        <div
                            className="flex items-center justify-between px-6 py-4"
                            style={{ background: "#1F2937" }}
                        >
                            <h2 className="text-lg font-semibold text-white">
                                Approval Details
                            </h2>

                            <button
                                onClick={() => setVendorApprovalModal(false)}
                                className="text-3xl leading-none text-white transition hover:text-gray-200"
                            >
                                &times;
                            </button>
                        </div>


                        <div className="max-h-[60vh] overflow-y-auto p-4 gap-4">
                            <div className="grid md:grid-cols-12 gap-4">

                                <div className="md:col-span-12">
                                    <label className="mb-2 block text-sm font-medium text-gray-700">
                                        Approval notes
                                    </label>

                                    <input
                                        type="text"
                                        name="approval_notes"
                                        value={formData.approval_notes || ""}
                                        onChange={handleChange}
                                        className="form-control focus:outline-none focus:ring-2 focus:ring-blue-200"
                                    />
                                </div>
                            </div>

                            <div className="text-center mt-4">
                                <button
                                    type="button"
                                    className="btn btn-sm btn-primary"
                                    onClick={updateApprovalReason}
                                >
                                    Send
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showVendorRejectedModal && selectedApproval && (
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
                    onClick={() => setVendorApprovalModal(false)}
                >
                    <div
                        className="w-[50%] overflow-hidden rounded-xl bg-white shadow-2xl"
                        onClick={(e) => e.stopPropagation()}
                    >

                        <div
                            className="flex items-center justify-between px-6 py-4"
                            style={{ background: "#1F2937" }}
                        >
                            <h2 className="text-lg font-semibold text-white">
                                Rejection Details
                            </h2>

                            <button
                                onClick={() => setVendorRejectedModal(false)}
                                className="text-3xl leading-none text-white transition hover:text-gray-200"
                            >
                                &times;
                            </button>
                        </div>


                        <div className="max-h-[60vh] overflow-y-auto p-4 gap-4">
                            <div className="grid md:grid-cols-12 gap-4">

                                <div className="md:col-span-12">
                                    <label className="mb-2 block text-sm font-medium text-gray-700">
                                        Rejection reason
                                    </label>

                                    <input
                                        type="text"
                                        name="rejection_reason"
                                        value={formData.rejection_reason || ""}
                                        onChange={handleChange}
                                        className="form-control focus:outline-none focus:ring-2 focus:ring-blue-200"
                                    />
                                </div>
                            </div>

                            <div className="text-center mt-4">
                                <button
                                    type="button"
                                    className="btn btn-sm btn-primary"
                                    onClick={updateApprovalReason}
                                >
                                    Send
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ApprovalsVendor;